import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-consistencycorner-dock-whiteshirt.jpg`;
const ALT = "Lara sitting cross-legged on a quiet dock at sunrise, writing in her journal beside still water.";

export function WhyItWorks() {
  return (
    <section data-testid="cc-why-it-works-section" className="relative overflow-hidden bg-[#FAFAF8] pt-[56px]">
      <div className="relative w-full overflow-hidden reveal pb-[46px] lg:pb-0">
        {/* Desktop: reflective image half-band on the right, dissolving on its inner edge */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[42.6%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="cc-why-it-works-image"
            bg="#FAFAF8"
            objectPosition="50% 30%"
            featherLeft={46}
            featherTop={10}
            featherBottom={10}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile: stacked on top */}
        <div className="lg:hidden relative w-full aspect-[3/4] mb-[30px]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="cc-why-it-works-image-mobile"
            bg="#FAFAF8"
            objectPosition="50% 12%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 lg:min-h-[627px] flex items-center">
          <div className="w-full lg:w-[62%] lg:pr-10">
            <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
              The Practice of Returning
            </p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[52px] leading-[1.1] tracking-tight text-[#1C1917] mb-5 max-w-lg">
              Consistency isn&rsquo;t never losing your way.
            </h2>
            <p className="font-display text-xl md:text-2xl text-[#57534E] italic leading-snug mb-7 max-w-lg">
              It&rsquo;s learning how to return without turning one hard week
              into a reason to quit.
            </p>
            <div className="space-y-4 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-[543px]">
              <p>Most meaningful things aren&rsquo;t built through one burst of motivation.</p>
              <p>
                They grow through small choices, honest adjustments and the
                willingness to begin again before beginning again becomes
                starting over.
              </p>
              <p>Consistency Corner gives you a rhythm.</p>
              <p>Not pressure.</p>
              <p>Not perfection.</p>
              <p className="text-[#1C1917]">
                A place to remember what matters and choose the next small
                step toward it.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
